import { Component, Input, OnChanges, OnInit, SimpleChanges, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../../services/core.user.service';
import { doGetPromise } from '../../../config/core.httpclient-utils';
import * as _ from 'lodash-es';
import { MenuService } from '../../../../widgets/mega-menu/mega-menu.service.component';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';
import { NotificationService } from '../../../services/core.notification.service';
import { FeatureFlagService } from '../../../services/core.feature-flags.service';
import { StateService } from '@uirouter/angular';
import { FavoritesService } from '../../../../widgets/favorites/favorites.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mega-menu',
    template: require('./mega.html')
})
export class MegaMenuComponent implements OnInit, OnChanges, OnDestroy {

    @Input() siteConfig: any = null;

    @Input() project: any = null;

    protected displayTab = '';
    protected projectMenu: any = false;
    protected topProjects = [];
    protected topOrgs = [];
    protected todoItems = [];
    protected todoItemCount = 0;
    protected recentItems: any = false;  // not currently populated
    protected user;

    private projectUnixName;

    protected miniMenuProject: any = false;
    protected miniLoading = false;

    protected hasUser;
    protected isSiteAdmin;

    protected profile;  // passthrough for language
    protected options;  // passthrough for featurelevel, stickytop, etc.

    // Favorites support
    favoritesCount = 0;
    private favoritesSubscription: Subscription;

    constructor(
        private window: Window,
        private stateService: StateService, 
        
        private httpClient: HttpClient,
        private userService: UserService,
        private menuService: MenuService,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
        private notificationService: NotificationService,
        public featureFlagService: FeatureFlagService,
        private favoritesService: FavoritesService
    ) {
        this.hasUser = this.userService.session.hasUser();
        this.isSiteAdmin = this.userService.session.isSiteAdmin();
    
        this.profile = this.userService.profile;  // passthrough for language
        this.options = this.userService.options;  // passthrough for featurelevel, stickytop, etc.

        this.notificationService.subscribe('mega-menu', 'queue-change', this.updateMenu);
        this.notificationService.subscribe('mega-menu', 'queue-data', 
            (data) => this.setTodoData(data)
        );
    }
    
    ngOnInit() {
        // Initialize favorites if user is logged in
        if (this.hasUser) {
            this.favoritesService.init().then(() => {
                this.favoritesCount = this.favoritesService.getFavoritesCount();
            });

            // Subscribe to favorites changes
            this.favoritesSubscription = this.favoritesService.favoritesChanged$.subscribe(() => {
                this.favoritesCount = this.favoritesService.getFavoritesCount();
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.user = this.userService.session.getUser();


        if (changes.hasOwnProperty('project')) {
            this.projectUnixName = _.get(this, 'project.unixName', false);
            this.updateMenu();
        }

        if (! this.displayTab) {
            this.displayTab = this.projectUnixName ?
                'project' : 'todo';
        }
    }

    ngOnDestroy() {
        this.notificationService.unsubscribe('mega-menu');
        if (this.favoritesSubscription) {
            this.favoritesSubscription.unsubscribe();
        }
    };

    optionButtonClass(isActive, activeClass?, inactiveClass?) {
        var active = 'btn-primary';
        if (undefined != activeClass) {
            active = activeClass;
        }

        var inactive = 'btn-default';
        if (undefined != inactiveClass) {
            inactive = inactiveClass;
        }

        return isActive ? active : inactive;
    };

    logout() {
        this.userService.session.logout()
            .then(
                (response) => {
                    var msgTitle = this.gfTranslateService.translate('Logged out');
                    var msgDescription = this.gfTranslateService.translate('You have been logged out of GForge');
                    this.uiService.message.showSuccess(msgDescription, msgTitle);
                }, () => {
                    var msgErrorTitle = this.gfTranslateService.translate('Logout error');
                    var msgErrorDescription = this.gfTranslateService.translate('There was a problem trying to log you out of GForge');
                    this.uiService.message.showError(msgErrorDescription, msgErrorTitle);
                }
            ).finally(() => {  this.stateService.go('home', {}, { reload: true }); });
    };

    showProjectMiniMenu(unixName) {

        // Toggle display if currently shown
        if (_.get(this, 'miniMenuProject.unixName', '') == unixName) {
            this.miniMenuProject = false;
            return false;
        }

        this.miniLoading = unixName;

        this.menuService.getProjectMenu(unixName).then(
            (pm) => {
                this.miniMenuProject = pm;
            }
        ).finally(() => { this.miniLoading = false; });
    };

    setTodoData(items) {
        this.todoItemCount = items.length;
        this.todoItems = 
        _.sortBy(
            items, ['-priority']
        ).slice(0, 5);
    }

    setDisplayTab(tabName) {
        if (tabName != this.displayTab) {
            this.displayTab = tabName;
        }
    }

    setMenuData(response) {
        var data = this.menuService.getDataFromAPIResponse(response);

        if (data) {
            this.menuService.setMenuData(data);

            //if status = 0 (pending), then schedule a refresh in 5 seconds
            if (_.get(data, 'projectMenu.status', -1) == 0) {
                this.window.setTimeout(this.updateMenu, 1000 * 5);
            }
        }

        this.projectMenu = _.get(data, 'projectMenu', false);
        this.topOrgs = _.get(data, 'topOrgs', []);
        this.topProjects = _.get(data, 'topProjects', []);
        this.notificationService.notifyAll('queue-data', _.get(data, 'todoItems', []));
    }

    updateMenu = () => {
        if (this.userService.session.hasUser()) {
            var url = `/site/mega/${ this.projectUnixName }?rp=1`;
            doGetPromise(this.httpClient, url)
                .then((response) => {
                    this.setMenuData(response);
                });
        } else {
            this.setMenuData(false);
        }
    }

    setFeatureLevel(name, level) {
        this.featureFlagService.setFeatureLevel(this.userService.getUnixName(), name, level);
    }

    trackById(index: number, item: any): any {
        return item.id;
    }
}
